















import Vue from "vue";
import { CloudSetting } from "../../models/CloudSetting";

export default Vue.extend({
  props: {
    value: {
      type: Object as () => CloudSetting,
      default: null
    },
    items: {
      type: Array as () => CloudSetting[],
      default: null
    }
  },
  data() {
    return {
      selectedValue: this.value ? this.value.deviceUDID : null
    };
  },
  watch: {
    selectedValue(newValue: string) {
      const filterResult = this.items.filter(x => x.deviceUDID == newValue);
      this.$emit("input", filterResult.length ? filterResult[0] : null);
    },
    value(newValue: CloudSetting) {
      this.selectedValue = newValue ? newValue.deviceUDID : null;
    }
  }
});
